import { render, staticRenderFns } from "./OpenBookingPayByMethod.vue?vue&type=template&id=2850eede&scoped=true"
import script from "./OpenBookingPayByMethod.vue?vue&type=script&lang=js"
export * from "./OpenBookingPayByMethod.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingPayByMethod.vue?vue&type=style&index=0&id=2850eede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850eede",
  null
  
)

export default component.exports